import React from "react";
import PropTypes from "prop-types";
import classes from "./myLessonCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import {
  LocationIconGray,
  CalendarIconGray,
  ClockIconGray,
  coachDemoImg,
  FlagIconBlack,
  CancelIconBlack,
  ChatBlackIcon,
} from "../../constant/imagePath";
import { ReactSVG } from "react-svg";
import { Tooltip } from "../Tooltip/index";

export const MyLessonCard = ({ data, onClick1, onClick2 }) => {
  return (
    <div
      className={`${[classes.card].join(" ")}`}
      style={{ borderColor: Colors.neutralShadesOfWhisper }}
    >
      <div className={`${[classes.profile].join(" ")}`}>
        <img src={data?.userData?.photo} />
      </div>
      <div className={` ${[classes.contentBox].join("")}`}>
        <div className={` ${[classes.header].join("")}`}>
          {/* Card Heading */}
          <div className={classes.headings}>
            <h5
              style={{
                ...Fonts.h5,
                color: Colors.neutralShadesOfNero,
              }}
            >
              {data?.requestType}
            </h5>{" "}
            <h5
              className={`${[classes.heading].join(" ")}`}
              style={{
                ...Fonts.h5,
                color: Colors.neutralShadesOfNero,
              }}
            >
              with {data?.userData?.displayName}
            </h5>
          </div>{" "}
          {/* Card Buttons */}
          <div>
            {data?.type === "pending" && (
              <div className="d-flex">
                <Tooltip
                  position="bottom"
                  text={"decline"}
                  className={classes?.iconBtnTooltipContainer}
                >
                  <Button
                    size={'Medium'}
                    icon={CancelIconBlack}
                    onClick={() => onClick1('cancel')}
                  />
                </Tooltip>
                <Button
                  label={"Accept"}
                  size={'Medium'}
                  customStyle={{
                    padding: "14px 42.5px",
                  }}
                  primary={true}
                  onClick={onClick2}
                />
              </div>
            )}

            {data?.type === "accepted" && (
              <div className="d-flex">
                <Tooltip
                  position="bottom"
                  text={"message"}
                  className={classes?.iconBtnTooltipContainer}
                >
                  <Button
                    size={'Medium'}
                    customStyle={{
                      color: Colors.neutralShadesOfNero,
                      padding: "12px",
                    }}
                    icon={ChatBlackIcon}
                    onClick={() => onClick1('chat')}
                  />
                </Tooltip>

                <Button
                  label={"Cancel"}
                  size={'Medium'}
                  customStyle={{
                    padding: "14px 42.5px",
                  }}
                  primary={false}
                  onClick={() => onClick2('cancel')}
                />
              </div>
            )}
            {data?.type === "completed" && (
              <div className="d-flex">
                <Tooltip
                  position="bottom"
                  text={"report"}
                  className={classes?.iconBtnTooltipContainer}
                >
                  <Button
                    size={'Medium'}
                    customStyle={{
                      padding: "12px",
                    }}
                    icon={FlagIconBlack}
                    onClick={() => onClick1('report')} />
                </Tooltip>

                <Button
                  label={"Leave Review"}
                  size={'Medium'}
                  customStyle={{
                    padding: "14px 24px",
                  }}
                  primary={false}
                  onClick={onClick2}
                />
              </div>
            )}

            {data?.type === "evaluate" && (
              <Button
                size={'Medium'}
                customStyle={{
                  padding: "14px 24px",
                }}
                onClick={() => onClick1('evaluate')}
                primary={true}
                label={"Evaluate"}
              />
            )}
            {data?.type === "read-evaluation" && (
              <div className="d-flex">
                <Button
                  size={'Medium'}
                  customStyle={{
                    padding: "14px 24px",
                  }}
                  label={"Read evaluation"}
                />
              </div>
            )}
          </div>
        </div>
        {/* Center Border */}
        <p className={` ${[classes.halfBorder].join(" ")}`} />
        {/* Main Content */}
        <div className={classes.lastline}>
          <ul>
            <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              <ReactSVG src={CalendarIconGray} />
              <span style={{ ...Fonts.p2 }}>{data?.date}</span>
            </li>
            <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              <ReactSVG src={ClockIconGray} />

              <span style={{ ...Fonts.p2 }}>{data?.time}</span>
            </li>
            <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              <ReactSVG src={LocationIconGray} />

              <span style={{ ...Fonts.p2 }}>{data?.location}</span>
            </li>
          </ul>
          {data?.timeLeft && (
            <p
              className={classes.time}
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
            >
              {data?.timeLeft} left
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

MyLessonCard.propType = {
  data: PropTypes.object,
  onClick1: PropTypes.func,
  onClick2: PropTypes.func,
};
MyLessonCard.defaultProps = {
  data: {
    userData: {
      displayName: "1-on-1 Tennis Lesson with Mackenzie McDonald",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "rejected",
  },
};
